import { alpha } from '@mui/material/styles';

// ----------------------------------------------------------------------

function createGradient(color1, color2) {
  return `linear-gradient(to bottom, ${color1}, ${color2})`;
}

// SETUP COLORS
const GREY = {
  0: '#FFFFFF',
  100: '#F9FAFB',
  200: '#F3F4F6',
  300: '#E5E7EB',
  400: '#D1D5DB',
  500: '#9CA3AF',
  600: '#6B7280',
  700: '#374151',
  800: '#1F2937',
  900: '#111827',
  500_8: alpha('#9CA3AF', 0.08),
  500_12: alpha('#9CA3AF', 0.12),
  500_16: alpha('#9CA3AF', 0.16),
  500_24: alpha('#9CA3AF', 0.24),
  500_32: alpha('#9CA3AF', 0.32),
  500_48: alpha('#9CA3AF', 0.48),
  500_56: alpha('#9CA3AF', 0.56),
  500_80: alpha('#9CA3AF', 0.8),
};

const PRIMARY = {
  lighter: '#EFF6FF',
  light: '#3B82F6',
  main: '#0066FE',
  dark: '#0052CC',
  darker: '#003D99',
  contrastText: '#FFFFFF',
};

const SECONDARY = {
  lighter: '#F3F4F6',
  light: '#9CA3AF',
  main: '#4B5563',
  dark: '#1F2937',
  darker: '#111827',
  contrastText: '#FFFFFF',
};

const INFO = {
  lighter: '#E0F2FE',
  light: '#38BDF8',
  main: '#0284C7',
  dark: '#0369A1',
  darker: '#075985',
  contrastText: '#FFFFFF',
};

const SUCCESS = {
  lighter: '#DCFCE7',
  light: '#4ADE80',
  main: '#16A34A',
  dark: '#15803D',
  darker: '#14532D',
  contrastText: '#FFFFFF',
};

const WARNING = {
  lighter: '#FEF3C7',
  light: '#FBBF24',
  main: '#D97706',
  dark: '#B45309',
  darker: '#78350F',
  contrastText: '#FFFFFF',
};

const ERROR = {
  lighter: '#FEE2E2',
  light: '#F87171',
  main: '#DC2626',
  dark: '#B91C1C',
  darker: '#7F1D1D',
  contrastText: '#FFFFFF',
};

const GRADIENTS = {
  primary: createGradient(PRIMARY.light, PRIMARY.main),
  info: createGradient(INFO.light, INFO.main),
  success: createGradient(SUCCESS.light, SUCCESS.main),
  warning: createGradient(WARNING.light, WARNING.main),
  error: createGradient(ERROR.light, ERROR.main),
};

const CHART_COLORS = {
  violet: ['#826AF9', '#9E86FF', '#D0AEFF', '#F7D2FF'],
  blue: ['#0066FE', '#3B82F6', '#93C5FD', '#EFF6FF'],
  green: ['#16A34A', '#4ADE80', '#86EFAC', '#DCFCE7'],
  yellow: ['#D97706', '#FBBF24', '#FDE68A', '#FEF3C7'],
  red: ['#DC2626', '#F87171', '#FCA5A5', '#FEE2E2'],
};

const palette = {
  common: { black: '#000', white: '#fff' },
  primary: { ...PRIMARY },
  secondary: { ...SECONDARY },
  info: { ...INFO },
  success: { ...SUCCESS },
  warning: { ...WARNING },
  error: { ...ERROR },
  grey: GREY,
  gradients: GRADIENTS,
  chart: CHART_COLORS,
  divider: '#ECEEF1',
  text: { primary: '#111827', secondary: '#6B7280', disabled: '#9CA3AF' },
  background: { paper: '#FFFFFF', default: '#F8F9FA', neutral: '#F3F4F6' },
  action: {
    active: GREY[600],
    hover: GREY[500_8],
    selected: GREY[500_16],
    disabled: GREY[500_80],
    disabledBackground: GREY[500_24],
    focus: GREY[500_24],
    hoverOpacity: 0.08,
    disabledOpacity: 0.48,
  },
};

export default palette;
